import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { httpGet } from 'giro-react-toolkit/source/UtilityFunctions/Ajax';

import {MapGeoJSONLayer} from 'Map';

/**
 * Routes map layer component
 */
class RoutesMapLayer extends Component {
   constructor(props) {
      super(props);
      this.state = { routes: [] };

      this.getRoutesMap = this.getRoutesMap.bind(this);

      this.abortController = null;
   }

   /**
    * Fetches the routes map from the web services
    */
   getRoutesMap() {
      // props must be initialized to fetch image
      if (!(this.props.day && this.props.concept && this.props.map)) {
         // remove the existing routes map layer
         this.setState({ routes: [] });
         return;
      }

      var params = {
         dayOfWeek: this.props.day,
         scenario: this.props.concept
      }

      // Cancel the in progress request.
      if (this.abortController)
         this.abortController.abort();

      if (window.AbortController)
         this.abortController = new AbortController();

      let signal = this.abortController ? this.abortController.signal : null;

      this.getRoutesMapRequest = httpGet('home/RoutesLayer', { params, fetchOptions: { signal } });

      this.getRoutesMapRequest
         .then(result => {
            this.setState({
               routes: result && result.Geometries ? result.Geometries : []
            });
         }).catch((error) => {
            if (!error.isCanceled) {
               // todo: gerer les erreurs
               this.setState({ routes: [] });
            }
         });
   }

   componentDidMount() {
      if (!this.props.map)
         return;

      this.getRoutesMap();
   }

   componentDidUpdate(prevProps) {
      // If props have changed, fetch new routes map
      if (this.props.day !== prevProps.day || this.props.concept !== prevProps.concept)
         this.getRoutesMap();
   }

   /**
    * render routes layer on map
    */
   render() {
      var data = {
         "type": "MultiLineString",
         "coordinates": this.state.routes
      };

      // get color concept from configs
      var concept = reachMap.concept.scenarios.find(item => {
         return item.Value === this.props.concept
      });

      var color;
      if (concept)
         color = concept.NetworkColor;

      if (this.state.routes.length)
         return (<MapGeoJSONLayer {...this.props} data={data} color={color}/>);

      return (null);
   }
}

RoutesMapLayer.propTypes = {
   /**
    * defines the day of the week (monday, tuesday, etc) for the routes map
    */
   day: PropTypes.string,
   /**
    * defines the selected concept
    */
   concept: PropTypes.string,
   /**
    * defines the map object on which to add the layer
    */
   map: PropTypes.object
}

export default RoutesMapLayer;
